import i18n from 'i18next';
import { isLotteryHasAnimation, lotteryParticipantTypes } from 'config/promoLotteryTypes';

function getWinnerLabelAndBtnTextGenerator({ lotteryType, customBtnText }) {
    if (lotteryType === lotteryParticipantTypes.PICK_THE_PRIZE) {
        return {
            header: count =>
                i18n.t('label.open_winner.pick_prize', {
                    count
                }),
            btn: () => i18n.t('btn.open_winner.client_pick')
        };
    } else if (isLotteryHasAnimation(lotteryType)) {
        return {
            header: count =>
                i18n.t('label.open_winner.pure_prize', {
                    count
                }),
            btn: () => customBtnText || i18n.t('btn.open_winner.pure_prize')
        };
    } else {
        return {
            header: count =>
                i18n.t('label.open_winner.prize', {
                    count
                }),
            btn: () => customBtnText || i18n.t('label.get_prize')
        };
    }
}

export default getWinnerLabelAndBtnTextGenerator;
